  <template>
    <ion-toolbar>
      <ion-title>
        <span>Guest {{ $filters.capitalize(message.locum) }}</span>
      </ion-title>
    </ion-toolbar>

    <div class="main_wrapper main_wrapper--custom ion-padding">
      <div class="container">
        <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="submit('userForm')">
          <div>
            <p>Hi,</p>
            <p>You have been invited to become a guest {{ message.locum }} for pharmacy <b>{{ pharmacyName }}</b>.
              Please fill up the form below and accept the invitation, to be a guest {{ message.locum }}.</p>
          </div>
          <el-form-item label="First Name" prop="firstName" :required="true">
            <el-input v-model="formsData.userForm.firstName.value" autocomplete="off" placeholder="First Name"
              :maxlength="20" @keyup="formsData.userForm.firstName.value = $event.target.value">
            </el-input>
          </el-form-item>
          <el-form-item label="Last Name" prop="lastName" :required="true">
            <el-input v-model="formsData.userForm.lastName.value" autocomplete="off" placeholder="Last Name"
              :maxlength="20" @keyup="formsData.userForm.lastName.value = $event.target.value"></el-input>
          </el-form-item>
          <el-form-item label="Phone Number" prop="mobileNumber" :required="true"
            class="collapsing-dropdown-scroll-off">
            <div class="el-input">
              <vue-tel-input class="el-input__inner" :value="formsData.userForm.mobileNumber.valueFormatted"
                v-model="formsData.userForm.mobileNumber.value" @input="onPhoneInput"
                :preferredCountries="[$filters.vueTelInput()]" :autoDefaultCountry="false"
                v-bind="{ mode: 'international' }"></vue-tel-input>
            </div>
          </el-form-item>
          <!-- <el-form-item label="Additional Terms and Conditions" prop="additionalTermCondition" :required="false">
          <el-input
            type="textarea"
            class="additional_term_condition"
            v-model="formsData.userForm.additionalTermCondition.value"
            placeholder="Enter your notes"
          ></el-input>
        </el-form-item> -->
          <div class="btns-group d-flex">
            <el-button class="submit_page flex-grow-1" type="red" @click="gotToReject()">
              Decline
            </el-button>
            <el-button class="submit_page flex-grow-1" type="blue" @click="submit('userForm')"
              :disabled="formsData.userForm.disabled">
              Accept
            </el-button>
          </div>
        </el-form>
      </div>
      <div class="el_dialog_wraper">
        <el-drawer :direction="'btt'" :show-close="false" class="success-prompt" custom-class="success-prompt"
          :destroy-on-close="true" :append-to-body="true" v-model="showAcceptRejectPopupMessage"
          :title="drawerContent.title" width="30%"
          @closed="showAcceptRejectPopupMessage = false">
          <div class="message text-center mt-3">
            <div class="col-right" v-if="drawerContent.status == 'accept'">
                <svg width="150" height="150" viewBox="0 0 309 309" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="154.5" cy="154.5" r="153.25" stroke="#009F98" stroke-width="1.5"
                    stroke-dasharray="3 5" />
                <circle cx="154.5" cy="154.5" r="137.5" fill="white" />
                <path
                    d="M223.733 140.046L217.067 134.952C217.933 131.869 218.667 129.256 219.333 126.977C222 117.996 223.467 113.037 219.8 107.944C216.133 102.85 211.133 102.649 201.667 102.381H193.4C192.267 99.4321 191.4 96.8184 190.6 94.6067C187.533 85.7603 185.8 81.203 179.8 78.9243C173.8 76.6457 169.6 79.8626 161.867 85.2241L155.2 89.8484L148.533 85.3581C141.667 79.9296 136.6 76.5787 130.533 78.5892C124.467 80.5998 122.867 85.2911 119.733 94.2046C118.933 96.4163 118 99.03 116.933 102.046L108.333 102.314C99 102.314 93.8667 102.649 90.2 107.742C86.5333 112.836 88.3333 117.795 90.8667 126.843C91.5333 129.121 92.3333 131.735 93.1333 134.818L86.4667 139.912C79.2 145.541 75 148.691 75 155.058C75 161.425 79.0667 164.507 86.4667 170.204L93.1333 175.298C92.3333 178.38 91.5333 180.994 90.8667 183.273C88.2 192.253 86.7333 197.213 90.4 202.306C94.0667 207.4 99.2667 207.534 108.533 207.802H116.733C117.867 210.751 118.733 213.364 119.533 215.576C122.667 224.422 124.333 228.98 130.333 231.258C136.333 233.537 140.533 230.32 148.267 224.959L154.933 220.334L161.6 224.824C165.712 228.443 170.787 230.772 176.2 231.526C177.402 231.514 178.595 231.31 179.733 230.923C185.733 228.98 187.4 224.221 190.533 215.308C191.333 213.096 192.2 210.482 193.333 207.534H201.6C210.933 207.534 216.067 207.199 219.733 202.038C223.4 196.878 222 191.985 219.333 183.005C218.667 180.726 217.867 178.112 217.067 175.029L223.733 169.936C231.067 164.641 235 161.76 235 155.058C235 148.356 231.067 145.742 223.733 140.046Z"
                    fill="#009F98" />
                <path
                    d="M144.133 190.309C143.232 190.271 142.348 190.05 141.534 189.658C140.721 189.266 139.994 188.713 139.4 188.031L119.733 165.981C118.557 164.648 117.957 162.9 118.063 161.122C118.169 159.343 118.974 157.68 120.3 156.498C121.626 155.316 123.365 154.712 125.134 154.819C126.903 154.926 128.557 155.735 129.733 157.068L144.533 173.89L186.733 132.606C187.341 131.914 188.085 131.356 188.917 130.967C189.749 130.578 190.653 130.366 191.571 130.344C192.488 130.322 193.401 130.491 194.251 130.84C195.101 131.189 195.87 131.711 196.509 132.372C197.149 133.034 197.646 133.822 197.969 134.686C198.292 135.55 198.434 136.471 198.387 137.393C198.339 138.315 198.102 139.216 197.691 140.042C197.281 140.867 196.705 141.599 196 142.19L148.8 188.567C147.526 189.732 145.854 190.356 144.133 190.309Z"
                    fill="white" />
            </svg>
            </div>
            <div class="col-right" v-else>
              <svg width="150" height="150" viewBox="0 0 309 309" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="154.5" cy="154.5" r="153.25" stroke="#009F98" stroke-width="1.5" stroke-dasharray="3 5"/>
                <circle cx="154.5" cy="154.5" r="137.5" fill="white"/>
                <path d="M223.733 140.046L217.067 134.952C217.933 131.869 218.667 129.256 219.333 126.977C222 117.996 223.467 113.037 219.8 107.944C216.133 102.85 211.133 102.649 201.667 102.381H193.4C192.267 99.4321 191.4 96.8184 190.6 94.6067C187.533 85.7603 185.8 81.203 179.8 78.9243C173.8 76.6457 169.6 79.8626 161.867 85.2241L155.2 89.8484L148.533 85.3581C141.667 79.9296 136.6 76.5787 130.533 78.5892C124.467 80.5998 122.867 85.2911 119.733 94.2046C118.933 96.4163 118 99.03 116.933 102.046L108.333 102.314C99 102.314 93.8667 102.649 90.2 107.742C86.5333 112.836 88.3333 117.795 90.8667 126.843C91.5333 129.121 92.3333 131.735 93.1333 134.818L86.4667 139.912C79.2 145.541 75 148.691 75 155.058C75 161.425 79.0667 164.507 86.4667 170.204L93.1333 175.297C92.3333 178.38 91.5333 180.994 90.8667 183.273C88.2 192.253 86.7333 197.213 90.4 202.306C94.0667 207.4 99.2667 207.534 108.533 207.802H116.733C117.867 210.751 118.733 213.364 119.533 215.576C122.667 224.422 124.333 228.98 130.333 231.258C136.333 233.537 140.533 230.32 148.267 224.959L154.933 220.334L161.6 224.824C165.712 228.443 170.787 230.772 176.2 231.526C177.402 231.514 178.595 231.31 179.733 230.923C185.733 228.98 187.4 224.221 190.533 215.308C191.333 213.096 192.2 210.482 193.333 207.534H201.6C210.933 207.534 216.067 207.198 219.733 202.038C223.4 196.878 222 191.985 219.333 183.005C218.667 180.726 217.867 178.112 217.067 175.029L223.733 169.936C231.067 164.641 235 161.76 235 155.058C235 148.356 231.067 145.742 223.733 140.046Z" fill="#E34457"/>
                <path d="M180.358 180.34C182.547 178.152 182.547 174.531 180.358 172.343L163 154.991L180.358 137.638C182.547 135.45 182.547 131.829 180.358 129.641C178.17 127.453 174.547 127.453 172.358 129.641L155 146.993L137.642 129.641C135.453 127.453 131.83 127.453 129.642 129.641C127.453 131.829 127.453 135.45 129.642 137.638L147 154.991L129.642 172.343C127.453 174.531 127.453 178.152 129.642 180.34C130.774 181.472 132.208 182 133.642 182C135.075 182 136.509 181.472 137.642 180.34L155 162.988L172.358 180.34C173.491 181.472 174.925 182 176.358 182C177.792 182 179.226 181.472 180.358 180.34Z" fill="white"/>
              </svg>
            </div>
            <div class="col-right">
              <p>{{ drawerContent.message }}</p>
            </div>
          </div>
          <span class="dialog-footer w-100">
            <el-button @click="close(drawerContent.status)" type="primary">{{ drawerContent.btnText }}</el-button>
          </span>
        </el-drawer>
      </div>
    </div>
  </template>

<script>


import {
  ref,
  onMounted,
  inject,
  // computed,
  defineAsyncComponent,
} from "vue";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import formValidate from "@/hooks/form/validate/validate";
import formHooks from "@/hooks/form/form";
const VueTelInput = defineAsyncComponent(() =>
  import("@/components/Vendor/vue-tel-input/components/vue-tel-input.vue")
);
addIcons({
  "arrow-back-outline": arrowBackOutline,
});

import { useStore } from "vuex";
import {
  useRouter,
  useRoute
} from "vue-router";
export default {
  components: {
    VueTelInput,
  },

  setup() {
    const $store = useStore();
    const $router = useRouter();
    const route = useRoute();
    const message = inject("messages");
    const $filters = inject("$filters");
    const showAcceptRejectPopupMessage = ref(false);
    const jobCreatePageData = $store.getters.getGuestShiftRecordCreatePageData;
    
    const userData = $store.getters.GET_USER_DATA;
    const termsAndCondition = userData.termsAndCondition ? userData.termsAndCondition : "";

    const setPageClassGlobal = inject("setPageClassGlobal");

    const drawerContent = ref({
      title: '',
      message: '',
      status:''
    });

    let pharmacyName = ref('');
    let pharmacyId = ref('');
    const close = (status) => {
      if(status == 'accept'){
        goBack();
      }else{
      $router.push({
        name: "auth",
      });
    }
    }

    const goBack = () => {
      $router.push({
        name: "search",
      });
    }

    const gotToReject = () => {
      (async () => {
        try {
          await $store.dispatch("GUEST_LOCUM_REJECT", { invitationId: route.params.invitationId, });
          drawerContent.value = {
            title: `Guest ${$filters.capitalize(message.locum)} Declined!`,
            message: `Guest ${$filters.capitalize(message.locum)} has been declined`,
            status:'reject',
            btnText: `Sign up to ${$filters.appName()}`
          };
          showAcceptRejectPopupMessage.value = true;

        } catch (error) {
          console.log(error);
          console.log("error submit!!");
        }
      })();
    }

    const formsDataArray = {
      userForm: {
        firstName: {
          value: jobCreatePageData.firstName ? jobCreatePageData.firstName : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "firstName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        lastName: {
          value: jobCreatePageData.lastName ? jobCreatePageData.lastName : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "lastName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        mobileNumber: {
          ref: {},
          value: jobCreatePageData.mobileNumber ? jobCreatePageData.mobileNumber : "",
          valueFormatted: jobCreatePageData.mobileNumber ? jobCreatePageData.mobileNumber : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "mobileNumber",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
          errors: null,
        },
      },
    };

    const onPhoneInput = (value, phoneObject) => {
      if (!value.target) {
        formsData.userForm.mobileNumber.ref.phoneObject = phoneObject;
      }
      formsData.userForm.mobileNumber.valueFormatted = value.target
        ? value.target.value
        : value;
      formsData.userForm.mobileNumber.value =
        formsData.userForm.mobileNumber.ref.phoneObject.number || null;

      checkFormValidation("userForm", false, "mobileNumber");
    };

    const submit = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          console.log('FORM VALUES:', getFormValues(formName));

          let data = getFormValues(formName);
          data.pharmacyId = pharmacyId.value;

          (async () => {
            try {
              await $store.dispatch("STORE_GUEST_LOCUM", {
                data,
                invitationId: route.params.invitationId,
              })

              drawerContent.value = {
                title: 'Thank you!',
                message: `You are now a guest ${ message.locum } for ${pharmacyName.value}`,
                status:'accept',
                btnText: 'Close'
              };
              
              showAcceptRejectPopupMessage.value = true;

            } catch (error) {
              console.log(error);
              console.log("error submit!!");
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };


    onMounted(() => {
      setPageClassGlobal("global_job_book_page");
      setFormRefs();
      (async () => {
        const guestInfo = await $store.dispatch("GET_GUEST_LOCUM_INFO", {
          invitationId: route.params.invitationId,
        });
        pharmacyName.value = guestInfo.pharmacyName;
        pharmacyId.value = guestInfo.pharmacyId;
      })();
      checkFormValidation("userForm", false);
    });


    const {
      checkFormValidation,
      setFormValidation,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);


    return {
      formsData,
      submit,
      gotToReject,
      pharmacyName,
      pharmacyId,
      onPhoneInput,
      close,
      termsAndCondition,
      message,
      showAcceptRejectPopupMessage,
      goBack,
      drawerContent
    };
  },
};
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
  height: 20px;
  /* You can adjust the height as needed */
}

.horizontal-line {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  border-top: 1px solid #000;
  /* Adjust the line style as needed */
}

.btns-group {
  margin-top: auto;
}
</style>